import { FC } from 'react';
import { RetryPaymentStatusEnum } from 'obt-common';
import { StyledButton } from './styles';
import useOnSubmit from '../hooks/useOnSubmit';
import useIsRetryPaymentInProgress from '../hooks/useIsRetryPaymentInProgress';

/**
 * A Spotnana checkout page styled button. Should be used
 * with a hook that handles submit
 */
const ConfirmationButton: FC = () => {
  const { onSubmit, disabled, text, status } = useOnSubmit();
  const isRetryPaymentInProgress = useIsRetryPaymentInProgress();

  return (
    <StyledButton
      onClick={onSubmit}
      loading={isRetryPaymentInProgress}
      disabled={status === RetryPaymentStatusEnum.RETRY_SUCCESS || disabled}
    >
      {text}
    </StyledButton>
  );
};

export default ConfirmationButton;
